import { CheckOutlined, PlusOutlined } from "@ant-design/icons";
import type { ICellRendererParams } from "ag-grid-community";
import React from "react";
import { Invoice } from "../types";

export type PendingInvoiceActionCellParams = ICellRendererParams<Invoice> & {
  addedInvoiceIds?: string[];
  disabled?: boolean;
  onAddInvoice?: (invoice: Invoice) => void;
};

export const PendingInvoiceActionCell: React.FC<PendingInvoiceActionCellParams> = (props) => {
  const record = props.data;
  if (!record?.pdcId) return <span />;

  const isAdded = props.addedInvoiceIds?.includes(record.pdcId);

  if (isAdded) return <CheckOutlined style={{ color: "#22a06b", fontSize: 14 }} />;

  return (
    <button
      type="button"
      disabled={props.disabled}
      style={{
        border: "none",
        background: "transparent",
        cursor: props.disabled ? "not-allowed" : "pointer",
        padding: 6,
        margin: 0,
        lineHeight: 0,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        color: "var(--blue-700)",
        opacity: props.disabled ? 0.5 : 1,
      }}
      onClick={(event) => {
        event.stopPropagation();
        event.preventDefault();
        props.onAddInvoice?.(record);
      }}
      aria-label={`Add ${record.invoiceNumber}`}
    >
      <PlusOutlined style={{ fontSize: 14 }} />
    </button>
  );
};
